import { Component, inject, type OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import type { TermAndCondition } from '@core/models/app.model';

import { OfferingTermsAndConditionsListComponent } from '../../../shared/offering-terms-and-conditions-list/offering-terms-and-conditions-list.component';

@UntilDestroy()
@Component({
  selector: 'ume-company-terms-and-conditions',
  templateUrl: './company-terms-and-conditions.component.html',
  styleUrls: ['./company-terms-and-conditions.component.scss'],
  imports: [OfferingTermsAndConditionsListComponent],
})
export class CompanyTACPageComponent implements OnInit {
  private readonly route: ActivatedRoute = inject(ActivatedRoute);

  public terms: TermAndCondition[] = [];

  ngOnInit(): void {
    this.route.data.pipe(untilDestroyed(this)).subscribe((data) => {
      this.terms = data.terms ?? [];
    });
  }
}
